module.exports = __webpack_public_path__ + "img/hb-back.95d2da1c.png";